import { CSSProperties, ReactNode } from 'react'

import { getImagePreviewTriggerProps, ImagePreviewTriggerOptions } from './image-preview-trigger'
import { ZoomHint } from './zoom-hint'
import * as S from './zoomable-image.styled'

interface ZoomFrameProps extends ImagePreviewTriggerOptions {
  children: ReactNode
  className?: string
  // Stretches the frame to its parent, for images that are sized by a surrounding container
  fill?: boolean
  hintSize?: string
  style?: CSSProperties
}

/**
 * Wraps an existing `<img>` so it opens `ImagePreviewModal` and shows the zoom overlay on hover.
 * Renders the children untouched when there is nothing to zoom (no src).
 */
export const ZoomFrame = ({
  children,
  className,
  fill = false,
  hintSize,
  style,
  ...options
}: ZoomFrameProps) => {
  const triggerProps = getImagePreviewTriggerProps(options)

  if (!triggerProps.onClick) return <>{children}</>

  return (
    <S.Frame {...triggerProps} $fill={fill} className={className} style={style}>
      {children}
      <ZoomHint size={hintSize} />
    </S.Frame>
  )
}
